import { ClipLoader } from 'react-spinners';
import React, { useEffect, useState } from 'react';
import TranslationService from '../../Translations/TranslationService';
import './main.css';
import { container } from 'tsyringe';
import EventBus from '../../Utils/EventBus';
export const CornerLoader = () => {
    const eventBus = container.resolve(EventBus);

    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const handleLoadingStart = () => setVisible(true);
        const handleLoadingEnd = () => setVisible(false);

        eventBus.addEventListener('loadingStart' as any, handleLoadingStart);
        eventBus.addEventListener('loadingEnd' as any, handleLoadingEnd);

        return () => {
            eventBus.removeEventListener('loadingStart' as any, handleLoadingStart);
            eventBus.removeEventListener('loadingEnd' as any, handleLoadingEnd);
        };
    }, []);

    return (
        <>
            {visible && (
                <div className="corner-loader">
                    <span>
                        {TranslationService.translate('vr.corner_loading')}
                    </span>
                    <ClipLoader
                        color={'#FFF'}
                        size={30}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                        className="corner-spinner"
                    />
                </div>
            )}
        </>
    );
};

export default CornerLoader;
